import HeaderOriginal from "../components/HeaderOriginal/HeaderOriginal";
import StickyNavBar from "../components/Navigation/StickyNavBar";
import Footer from "../components/Footer";
import Container from "../components/Container";
import VerticalDisplayImage from "../components/Images/VerticalDisplayImage";

import Fancybox from "../components/FancyBox";
import React from "react";

const AssociationRegistrationCertificate = () => {
  React.useEffect(() => {
    Fancybox.bind("[data-fancybox='images']");
  }, []);

  const imagesData = [
    {
      url: "images/about/certificates/association_registration_certificate.png",
      alt: "Association Registration Certificate",
      filename: "association_registration_certificate",
    },
  ];

  return (
    <>
      <HeaderOriginal></HeaderOriginal>
      <StickyNavBar></StickyNavBar>
      <Container>
        <div className="py-12 md:py-16 lg:py-24">
          <h1 className="font-bold text-lg md:text-xl lg:text-2xl mb-2 md:mb-4 text-[#21497C] text-center">
            شهادة تسجيل الجمعية
          </h1>
          <div className="grid gap-4">
            <Fancybox
              options={{
                Carousel: {
                  infinite: true,
                },
              }}
            >
              {imagesData.map((image, index) => {
                const { url, alt, filename } = image;
                return (
                  <a key={index} data-fancybox="gallery" href={url}>
                    <VerticalDisplayImage
                      key={filename}
                      url={url}
                      alt={alt}
                      filename={filename}
                    />
                  </a>
                );
              })}
            </Fancybox>
          </div>
        </div>
      </Container>
      <Footer></Footer>
    </>
  );
};

export default AssociationRegistrationCertificate;
